module.exports = __webpack_public_path__ + "static/media/TradeGothicLTPro-BdCn20.1de79686.ttf";